<template>

    <div class="content">

        <div class="text">

            <h4>Psychologische Psychotherapeutin</h4>
            <h2>Swenja Kastenmiller</h2><br>
        </div>

        <!--        Rosenheimer Landstraße 72<br>-->
        <!--        85521 Ottobrunn<br><br>-->

        <!--        Verhaltenstherapie-->

        <!--        <br>-->
        <!--        - alle Kassen, Privat- und Selbstzahler - -->
        <!--        &lt;!&ndash;        <hr class="my-4">&ndash;&gt;-->
        <!--        <p>-->
        <!--            Sprechzeiten nach telefonischer Vereinbarung.-->
        <!--        </p>-->
        <!--        <p>-->
        <!--            Tel.: (089) 95864402-->
        <!--        </p>-->
        <!--        <p>-->
        <!--            telefonische Sprechzeiten:-->
        <!--            <br>-->
        <!--            Montag 09:00 – 09:50-->
        <!--            <br>-->
        <!--            Donnerstag 13:00 – 13:50-->
        <!--        </p>-->

    </div>

</template>

<script>
    export default {
        name: 'ContentWelcome',
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .content {
        min-height: calc(100vh - 60px);
        background-image: url("../assets/swenja-welcome.web.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left;
        text-shadow: 1px 1px 4px black;
        color: white;
        border-radius: 0;
    }

    .text {
        margin-right: 2em;
        text-align: right;
        position: absolute;
        bottom: 0;
        right: 0;
    }

    @media (max-aspect-ratio: 10/16) {
        .content {
            /*border: 2px solid red;*/
            /* on narrow devices, make sure the face is not cut */
            background-position-x: -20vh;
        }
    }
</style>
